import http from "@/services/axios";
import { defineStore } from "pinia";
import { ref, onUnmounted } from "vue";

export const useNotificationStore = defineStore("notifications", () => {
    const notifications = ref([]);
    const currentPage = ref(1);
    const perPage = ref(15);
    const total = ref(0);
    const lastPage = ref(1);
    const count = ref(0);

    let pollInterval = null; // store the interval reference

    const fetch_all_notifications = async (page = 1, append = false) => {
        try {
            const { data } = await http.get("/notifications", {
                params: { page, per_page: perPage.value },
            });

            if (append) {
                notifications.value = [...notifications.value, ...data.data];
            } else {
                notifications.value = data.data;
            }

            currentPage.value = data.meta.current_page;
            perPage.value = data.meta.per_page;
            total.value = data.meta.total;
            lastPage.value = data.meta.last_page;

            return notifications.value;
        } catch (error) {
            console.error("Error fetching notifications:", error);
        }
    };

    const load_more_notifications = async () => {
        if (currentPage.value < lastPage.value) {
            await fetch_all_notifications(currentPage.value + 1, true);
        }
    };

    const count_all_notif = async () => {
        try {
            const { data } = await http.get("/notifications/count");
            count.value = data;
            return data;
        } catch (error) {
            console.error("Error fetching notification count:", error);
        }
    };

    const startPolling = (interval = 300) => {
        if (pollInterval) return; // avoid multiple intervals
        pollInterval = setInterval(async () => {
            await count_all_notif();
        }, interval);
    };

    const stopPolling = () => {
        if (pollInterval) {
            clearInterval(pollInterval);
            pollInterval = null;
        }
    };

    // Auto-cleanup if store is disposed
    onUnmounted(() => {
        stopPolling();
    });

    return {
        notifications,
        currentPage,
        perPage,
        total,
        lastPage,
        count,
        fetch_all_notifications,
        load_more_notifications,
        count_all_notif,
        startPolling,
        stopPolling,
    };
});
